import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function PartnersSection() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/partners", { params: { active_only: true } }).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  // duplicate items for seamless marquee
  const doubled = [...items, ...items];

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="kicker mb-3">Our Partners</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0B2A6B]">
            Trusted by leading <span className="text-yellow-500">global brands</span>
          </h2>
        </div>

        <div className="relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-slate-50 to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-slate-50 to-transparent z-10" />

          <div className="flex gap-6 w-max animate-marquee">
            {doubled.map((p, i) => (
              <div
                key={`${p.id}-${i}`}
                className="shrink-0 w-56 h-28 rounded-2xl bg-white shadow-sm border border-slate-100 flex flex-col items-center justify-center px-4 hover:shadow-lg hover:-translate-y-1 transition group"
              >
                <div className="font-bold text-[#0B2A6B] text-base group-hover:text-yellow-600 transition text-center">
                  {p.name}
                </div>
                {p.role && <div className="text-xs text-slate-500 mt-1 text-center">{p.role}</div>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
